module.exports = __webpack_public_path__ + "static/media/gry-edukacyjne-dla-12-latka-13-latka.e04e0c35.png";